import { X } from 'lucide-react';
import { format } from 'date-fns';
import styles from './EventPopup.module.scss';
import { EventPopup } from './EventPopup';
import { useState, useRef, useEffect } from 'react';

export function MoreEventsPopup({ date, events, onClose, position }) {
    const [selectedEvent, setSelectedEvent] = useState(null);
    const popupRef = useRef(null);

    useEffect(() => {
        if (popupRef.current) {
            const popup = popupRef.current;
            const rect = popup.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            let left = Math.max(20, Math.min(
                position.x,
                viewportWidth - rect.width - 20
            ));

            let top = Math.max(20, Math.min(
                (viewportHeight - rect.height) / 2,
                viewportHeight - rect.height - 20
            ));

            popup.style.left = `${left}px`;
            popup.style.top = `${top}px`;
        }
    }, [position]);

    const handleEventClick = (event, e) => {
        e.stopPropagation();
        setSelectedEvent({
            event,
            position: {
                x: e.clientX,
                y: e.clientY
            }
        });
    };

    const handleEventPopupClose = () => {
        setSelectedEvent(null);
    };

    return (
        <>
            <div className="fixed inset-0 z-50 bg-black/20" onClick={onClose}>
                <div
                    ref={popupRef}
                    className={`absolute bg-white rounded-lg shadow-xl w-[320px] max-h-[400px] overflow-auto ${styles.customScroll}`}
                    onClick={e => e.stopPropagation()}
                >
                    <div className="p-4">
                        <div className="flex justify-between items-start border-b border-gray-200 pb-4">
                            <div className="w-full flex flex-col items-center">
                                <div className="text-md font-bold text-black">
                                    {format(date, 'EEEE')}
                                </div>
                                <div className="text-lg font-bold text-primary">
                                    {format(date, 'd')}
                                </div>
                            </div>
                            <button
                                onClick={onClose}
                                className="text-gray-500 hover:text-gray-700"
                            >
                                <X className="w-5 h-5" />
                            </button>
                        </div>
                        <div className="mt-4 space-y-2">
                            {events.map((event, index) => (
                                <div
                                    key={index}
                                    className="flex items-center hover:bg-gray-50 rounded cursor-pointer p-2"
                                    onClick={(e) => handleEventClick(event, e)}
                                >
                                    <div className="flex items-center gap-1 w-full">
                                        <div className="text-sm text-primary min-w-[60px]">
                                            {format(event.start, 'hh:mm')}
                                            <span className="text-xs ml-0.5">
                                                {format(event.start, 'a')}
                                            </span>
                                        </div>
                                        <div className="font-medium text-sm text-gray-600">
                                            {event.title}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {selectedEvent && (
                <EventPopup
                    event={selectedEvent.event}
                    position={selectedEvent.position}
                    onClose={handleEventPopupClose}
                    type={selectedEvent.event.type || 'default'}
                />
            )}
        </>
    );
}